import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { HashRouter as Router } from 'react-router-dom';
import configureStore from './redux/configStore';
import { Provider as ReduxProvider } from 'react-redux';
import { persistStore } from 'redux-persist';
//THEME
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeProvider } from 'styled-components';
import LabsTheme from './styles/theme/LabsTheme';
//CSS
import './styles/index.scss';

//Initializing the store and passing to the root component.
const store = configureStore();
//Persisting the redux store and rehydrating back redux store on page reloads. using Redux-persist
persistStore(store);
ReactDOM.render(
	<ReduxProvider store={store}>
		<Router>
			<MuiThemeProvider theme={LabsTheme}>
				<ThemeProvider theme={LabsTheme}>
					<App />
				</ThemeProvider>
			</MuiThemeProvider>
		</Router>
	</ReduxProvider>,
	document.getElementById('root'),
);

if (typeof window['Cypress'] !== 'undefined') {
	window['store'] = store;
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
